import { render, staticRenderFns } from "./chemical-engineering-3.vue?vue&type=template&id=5ea4d5b1&scoped=true&"
import script from "./chemical-engineering-3.vue?vue&type=script&lang=js&"
export * from "./chemical-engineering-3.vue?vue&type=script&lang=js&"
import style0 from "./chemical-engineering-3.vue?vue&type=style&index=0&id=5ea4d5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4d5b1",
  null
  
)

export default component.exports